module.exports = __webpack_public_path__ + "img/58_21.6ab450ac.png";